import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import User from 'models/user';
import BookingModel from 'models/booking';

const propTypes = {
  user: PropTypes.instanceOf(User).isRequired,
  booking: PropTypes.instanceOf(BookingModel).isRequired,
};

const NameOnReceipt = ({ user, booking }) => {
  if (!booking.showNameOnPass) return null;
  return (
    <div className="col-sm-11 col-xs-12 background-color-light-blue margin-bottom-xs-20 padding-xs-20 margin-left-sm-15 margin-left-xs-0">
      <div className="text-size-sm-18 text-size-xs-16 text-color-dark-slate text-weight-bold">
        NAME MUST MATCH PHOTO ID
      </div>
      <div className="text-size-sm-24 text-size-xs-20 text-color-dark-slate text-weight-book padding-top-xs-20 padding-bottom-xs-20">
        {user.firstname} {user.lastname}</div>
      <div className="text-size-12 text-color-dark-slate text-weight-book">
        To update, you’ll need to cancel this booking then re-book with your name updated.<br />
        If you have an account, update how your name appears in <Link className="text-weight-bold" to={{ pathname: '/account/settings/' }}>Account Settings</Link> before re-booking.
      </div>
    </div>
  );
};

NameOnReceipt.propTypes = propTypes;

export default NameOnReceipt;

